import React, { useContext, useEffect, useState } from "react";
import Nav from "./Nav";
import Catalog from "./Catalog";
import InicioContext from "./InicioContext";

function Inicio() {
  const [acao, setAcao] = useState([]);
  const [ficcao, setFiccao] = useState([]);
  const [romance, setRomance] = useState([]);
  const [autoAjuda, setAutoAjuda] = useState([]);
  const data = useContext(InicioContext);
  const { createCatalogo, backEnd } = data;

  function send(kind) {
    const dataToSend = {
      book: kind,
    };

    return fetch(backEnd + "/api", {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Invalid response");
        }
      })
      .then((data) => {
        const newData = [];
        for (let i = 0; i < data.booksTitle.length; i++) {
          if (data.booksTitle[i] !== "" && data.booksimg[i] !== "") {
            newData.push({
              from: "Inicio",
              titles: data.booksTitle[i],
              imgs: data.booksimg[i],
              pages: data.pages[i],
              desc: data.desc[i],
            });
          }
        }
        return newData;
      })
      .catch((error) => {
        console.error(error);
        return [];
      });
  }

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        
        // Verifica se os dados estão em cache no localStorage
        const cachedAcaoData = localStorage.getItem("acaoData");
        const cachedFiccaoData = localStorage.getItem("ficcaoData");
        const cachedRomanceData = localStorage.getItem("romanceData");
        const cachedAutoAjudaData = localStorage.getItem("autoAjudaData");

        if (cachedAcaoData && cachedFiccaoData && cachedRomanceData && cachedAutoAjudaData) {
          // Se os dados estiverem em cache, usa os dados em cache
          setAcao(JSON.parse(cachedAcaoData));
          setFiccao(JSON.parse(cachedFiccaoData));
          setRomance(JSON.parse(cachedRomanceData));
          setAutoAjuda(JSON.parse(cachedAutoAjudaData));
        } else {
          // Caso contrário, busca os dados da API e os armazena em cache
          const acaoData = await send("ação e aventura");
          const ficcaoData = await send("ficcao");
          const romanceData = await send("romance");
          const autoAjudaData = await send("autoAjuda");

          setAcao(acaoData);
          setFiccao(ficcaoData);
          setRomance(romanceData);
          setAutoAjuda(autoAjudaData);

          // Armazena os dados em cache no localStorage
          localStorage.setItem("acaoData", JSON.stringify(acaoData));
          localStorage.setItem("ficcaoData", JSON.stringify(ficcaoData));
          localStorage.setItem("romanceData", JSON.stringify(romanceData));
          localStorage.setItem("autoAjudaData", JSON.stringify(autoAjudaData));
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchBooks();
  }, []);

  return (
    <div>
      <Nav />
      <div className="Catalogando">
        <Catalog Name={"Ação"} ArrayMapping={acao} Catalogo={createCatalogo} />
        <Catalog Name={"Ficção"} ArrayMapping={ficcao} Catalogo={createCatalogo} />
        <Catalog Name={"Romance"} ArrayMapping={romance} Catalogo={createCatalogo} />
        <Catalog Name={"Auto-ajuda"} ArrayMapping={autoAjuda} Catalogo={createCatalogo} />
      </div>
    </div>
  );
}

export default Inicio;
